import { ItemDataInput } from "../../models/item-data-models";
import { EndgameContent } from "../../models/enums";

export const regularRuneBaseTypeEntries: [string, string][] = [
  ['Desert Rune', 'firerune.webp'],
  ['Glacial Rune', 'coldrune.webp'],
  ['Storm Rune', 'lightningrune.webp'],
  ['Iron Rune', 'enhancerune.webp'],
  ['Body Rune', 'liferune.webp'],
  ['Mind Rune', 'manarune.webp'],
  ['Rebirth Rune', 'liferecoveryrune.webp'],
  ['Inspiration Rune', 'manarecoveryrune.webp'],
  ['Stone Rune', 'stunrune.webp'],
  ['Vision Rune', 'accuracyrune.webp'],
  ['Robust Rune', 'strengthrune.webp'],
  ['Adept Rune', 'dexrune.webp'],
  ['Resolve Rune', 'intrune.webp'],
  ['Lesser Desert Rune', 'firerunetier1.webp'],
  ['Lesser Glacial Rune', 'coldrunetier1.webp'],
  ['Lesser Storm Rune', 'lightningrunetier1.webp'],
  ['Lesser Iron Rune', 'enhancerunetier1.webp'],
  ['Lesser Body Rune', 'liferunetier1.webp'],
  ['Lesser Mind Rune', 'manarunetier1.webp'],
  ['Lesser Rebirth Rune', 'liferecoveryrunetier1.webp'],
  ['Lesser Inspiration Rune', 'manarecoveryrunetier1.webp'],
  ['Lesser Stone Rune', 'stunrunetier1.webp'],
  ['Lesser Vision Rune', 'accuracyrunetier1.webp'],
  ['Lesser Robust Rune', 'strengthrunetier1.webp'],
  ['Lesser Adept Rune', 'dexrunetier1.webp'],
  ['Lesser Resolve Rune', 'intrunetier1.webp'],
  ['Greater Desert Rune', 'firerunetier2.webp'],
  ['Greater Glacial Rune', 'coldrunetier2.webp'],
  ['Greater Storm Rune', 'lightningrunetier2.webp'],
  ['Greater Iron Rune', 'enhancerunetier2.webp'],
  ['Greater Body Rune', 'liferunetier2.webp'],
  ['Greater Mind Rune', 'manarunetier2.webp'],
  ['Greater Rebirth Rune', 'liferecoveryrunetier2.webp'],
  ['Greater Inspiration Rune', 'manarecoveryrunetier2.webp'],
  ['Greater Stone Rune', 'stunrunetier2.webp'],
  ['Greater Vision Rune', 'accuracyrunetier2.webp'],
  ['Greater Robust Rune', 'strengthrunetier3.webp'],
  ['Greater Adept Rune', 'dexrunetier3.webp'],
  ['Greater Resolve Rune', 'intrunetier3.webp'],
  // New in 0.5
  ['Lesser Ward Rune', 'AddedWardLesser.webp'],
  ['Ward Rune', 'AddedWardNormal.webp'],
  ['Greater Ward Rune', 'AddedWardGreater.webp'],
  ['Lesser Charging Rune', 'WardRegenerationLesser.webp'],
  ['Charging Rune', 'WardRegenerationNormal.webp'],
  ['Greater Charging Rune', 'WardRegenerationGreater.webp'],
];

export const manualItemData: ItemDataInput[] = [
{
  "itemType": "Trial Coins",
  "tierListItemType": "Map Fragments",
  "itemClass": "Trial Coins",
  "currencySearchName": "Trial Coin",
  "content": EndgameContent.SekhemasTrial,
  "isCurrency": true,
  "baseTypes": [
    "Djinn Barya|/img/currency/sanctum/balbalacoin1.webp",
  ]
},
{
  "itemType": "Gold",
  "tierListItemType": "Gold",
  "itemClass": "Stackable Currency",
  "currencySearchName": "Gold",
  "isCurrency": false,
  "baseTypes": [
    "Gold|/img/currency/CoinPileTier2.webp",
  ]
},
{
  "itemType": "Verisium",
  "tierListItemType": "Verisium",
  "itemClass": "Stackable Currency",
  "currencySearchName": "Verisium",
  "content": EndgameContent.Expedition,
  "isCurrency": false,
  "baseTypes": [
    "Verisium|/img/currency/refinedverisium.webp",
  ]
},
{
  "itemType": "Ultimatums",
  "tierListItemType": "Map Fragments",
  "itemClass": "Inscribed Ultimatum",
  "currencySearchName": "Ultimatum",
  "content": EndgameContent.ChaosTrial,
  "isCurrency": true,
  "baseTypes": [
    "Inscribed Ultimatum|/img/currency/maps/ultimatumtrialitem.webp",
  ]
},
{
  "itemType": "Expedition Logbooks",
  "tierListItemType": "Expedition",
  "content": EndgameContent.Expedition,
  "itemClass": "Expedition Logbook", // Switched from plural to singular in 0.5
  "currencySearchName": "Expedition Logbook",
  "isCurrency": true,
  "baseTypes": [
    "Expedition Logbook|/img/currency/expedition/ExpeditionLogbook.png",
  ]
},
{
  "itemType": "Splinters",
  "tierListItemType": "Map Fragments",
  "itemClass": "Stackable Currency",
  "currencySearchName": "Splinter",
  "isCurrency": true,
  "baseTypes": [
    "Breach Splinter|/img/currency/breach/breachstonesplinter.webp",
    "Simulacrum Splinter|/img/currency/distilledemotions/deliriumsplinter.webp",
  ]
},
{
  "itemType": "Uncut Skill Gems",
  "itemClass": "Uncut Skill Gems",
  "currencySearchName": "Uncut Skill Gem",
  "tierListItemType": "Uncut Gems",
  "isCurrency": true,
  "baseTypes": [
    "Uncut Skill Gem (Level 1)|/img/currency/UncutSkillGem.webp",
    "Uncut Skill Gem (Level 2)|/img/currency/UncutSkillGem.webp",
    "Uncut Skill Gem (Level 3)|/img/currency/UncutSkillGem.webp",
    "Uncut Skill Gem (Level 4)|/img/currency/UncutSkillGem.webp",
    "Uncut Skill Gem (Level 5)|/img/currency/UncutSkillGem.webp",
    "Uncut Skill Gem (Level 6)|/img/currency/UncutSkillGem.webp",
    "Uncut Skill Gem (Level 7)|/img/currency/UncutSkillGem.webp",
    "Uncut Skill Gem (Level 8)|/img/currency/UncutSkillGem.webp",
    "Uncut Skill Gem (Level 9)|/img/currency/UncutSkillGem.webp",
    "Uncut Skill Gem (Level 10)|/img/currency/UncutSkillGem.webp",
    "Uncut Skill Gem (Level 11)|/img/currency/UncutSkillGem.webp",
    "Uncut Skill Gem (Level 12)|/img/currency/UncutSkillGem.webp",
    "Uncut Skill Gem (Level 13)|/img/currency/UncutSkillGem.webp",
    "Uncut Skill Gem (Level 14)|/img/currency/UncutSkillGem.webp",
    "Uncut Skill Gem (Level 15)|/img/currency/UncutSkillGem.webp",
    "Uncut Skill Gem (Level 16)|/img/currency/UncutSkillGem.webp",
    "Uncut Skill Gem (Level 17)|/img/currency/UncutSkillGem.webp",
    "Uncut Skill Gem (Level 18)|/img/currency/UncutSkillGem.webp",
    "Uncut Skill Gem (Level 19)|/img/currency/UncutSkillGem.webp",
    "Uncut Skill Gem (Level 20)|/img/currency/UncutSkillGem.webp",
  ]
},
{
  "itemType": "Uncut Support Gems",
  "itemClass": "Uncut Support Gems",
  "currencySearchName": "Uncut Support Gem",
  "tierListItemType": "Uncut Gems",
  "isCurrency": true,
  "baseTypes": [
    "Uncut Support Gem (Level 1)|/img/currency/UncutSupportGem.webp",
    "Uncut Support Gem (Level 2)|/img/currency/UncutSupportGem.webp",
    "Uncut Support Gem (Level 3)|/img/currency/UncutSupportGem.webp",
    "Uncut Support Gem (Level 4)|/img/currency/UncutSupportGem.webp",
    "Uncut Support Gem (Level 5)|/img/currency/UncutSupportGem.webp",
  ]
},
{
  "itemType": "Uncut Spirit Gems",
  "itemClass": "Uncut Spirit Gems",
  "currencySearchName": "Uncut Spirit Gem",
  "tierListItemType": "Uncut Gems",
  "isCurrency": true,
  "baseTypes": [
    "Uncut Spirit Gem (Level 4)|/img/currency/UncutSkillGemBuff.webp",
    "Uncut Spirit Gem (Level 5)|/img/currency/UncutSkillGemBuff.webp",
    "Uncut Spirit Gem (Level 6)|/img/currency/UncutSkillGemBuff.webp",
    "Uncut Spirit Gem (Level 7)|/img/currency/UncutSkillGemBuff.webp",
    "Uncut Spirit Gem (Level 8)|/img/currency/UncutSkillGemBuff.webp",
    "Uncut Spirit Gem (Level 9)|/img/currency/UncutSkillGemBuff.webp",
    "Uncut Spirit Gem (Level 10)|/img/currency/UncutSkillGemBuff.webp",
    "Uncut Spirit Gem (Level 11)|/img/currency/UncutSkillGemBuff.webp",
    "Uncut Spirit Gem (Level 12)|/img/currency/UncutSkillGemBuff.webp",
    "Uncut Spirit Gem (Level 13)|/img/currency/UncutSkillGemBuff.webp",
    "Uncut Spirit Gem (Level 14)|/img/currency/UncutSkillGemBuff.webp",
    "Uncut Spirit Gem (Level 15)|/img/currency/UncutSkillGemBuff.webp",
    "Uncut Spirit Gem (Level 16)|/img/currency/UncutSkillGemBuff.webp",
    "Uncut Spirit Gem (Level 17)|/img/currency/UncutSkillGemBuff.webp",
    "Uncut Spirit Gem (Level 18)|/img/currency/UncutSkillGemBuff.webp",
    "Uncut Spirit Gem (Level 19)|/img/currency/UncutSkillGemBuff.webp",
    "Uncut Spirit Gem (Level 20)|/img/currency/UncutSkillGemBuff.webp",
  ]
},
{
  "itemType": "Pinnacle Keys",
  "tierListItemType": "Map Fragments",
  "itemClass": "Pinnacle Keys",
  "currencySearchName": "Pinnacle Key",
  "isCurrency": true,
  "content": EndgameContent.Monolith,
  "baseTypes": [
    "Ancient Crisis Fragment|/img/currency/maps/pinnaclekey1.webp",
    "Faded Crisis Fragment|/img/currency/maps/pinnaclekey2.webp",
    "Weathered Crisis Fragment|/img/currency/maps/pinnaclekey3.webp",
    // "Primary Calamity Fragment|/img/currency/maps/pinnaclekey1.webp",
    // "Secondary Calamity Fragment|/img/currency/maps/pinnaclekey2.webp",
    // "Tertiary Calamity Fragment|/img/currency/maps/pinnaclekey3.webp",
    // 0.5.0
    "Call of the Shadows|/img/currency/maps/RitualEffigyPieces.webp",
    "Origin Cradle|/img/currency/PrecursorEgg.webp",
    "Origin Spark|/img/currency/PrecursorSeed.webp",
    "Origin Core|/img/currency/PrecursorSeedEggCombined.webp",
  ]
},
{
  "itemType": "Map Fragments",
  "itemClass": "Map Fragments",
  "currencySearchName": "Map Fragment",
  "isCurrency": true,
  "baseTypes": [
    "Cowardly Fate|/img/currency/maps/trialmasterkey1.webp",
    "Deadly Fate|/img/currency/maps/trialmasterkey2.webp",
    "Victorious Fate|/img/currency/maps/trialmasterkey3.webp",
    "Kulemak's Invitation|/img/currency/maps/voodookingeffigy.webp",
    "An Audience with the King|/img/currency/maps/voodookingeffigy.webp",
    "Simulacrum|/img/currency/maps/deliriumfragment.webp",
    // 0.5.0 - TODO: update images for The Triskelion Reforged, Raven's Reflection (not yet in poe2-images.json)
    "The Triskelion Reforged|/img/currency/maps/voodookingeffigy.webp",
    "Head of the King|/img/currency/maps/KingoftheMistHead.webp",
    "Breachlord Sac|/img/currency/maps/BreachlordSac.webp",
    "Raven's Reflection|/img/currency/maps/voodookingeffigy.webp",
  ]
},
{
  "itemType": "Breachstones",
  "tierListItemType": "Breach",
  "content": EndgameContent.Breach,
  "itemClass": "Breachstones",
  "currencySearchName": "Breachstone",
  "imageBaseUrl": "/img/currency/breach/",
  "isCurrency": true,
  "baseTypes": [
    "Breachstone|breachstone.webp",
  ]
},
{
  "itemType": "Vault Keys",
  "itemClass": "Vault Keys",
  "currencySearchName": "Vault Key",
  "isCurrency": true,
  "imageBaseUrl": "/img/currency/sanctum/",
  "baseTypes": [
    "Twilight Reliquary Key|twilightorderreliquarykeyworld.webp",
    "Xesht's Reliquary Key|twilightorderreliquarykeybreach.webp",
    "The Trialmaster's Reliquary Key|twilightorderreliquarykeyultimatum.webp",
    "Ritualistic Reliquary Key|twilightorderreliquarykeyritual.webp",
    "Tangmazu's Reliquary Key|twilightorderreliquarykeydelirium.webp",
    "Olroth's Reliquary Key|twilightorderreliquarykeyexpedition.webp",
    "The Arbiter's Reliquary Key|twilightorderreliquarykeypinnacle.webp",
    "Zarokh's Reliquary Key: Against the Darkness|twilightorderreliquarykeysanctum2.webp",
    "Zarokh's Reliquary Key: Sandstorm Visage|twilightorderreliquarykeysanctum3.webp",
    "Zarokh's Reliquary Key: Blessed Bonds|twilightorderreliquarykeysanctum4.webp",
    "Zarokh's Reliquary Key: Sekhema's Resolve|twilightorderreliquarykeysanctum5.webp",
    "Zarokh's Reliquary Key: Temporalis|twilightorderreliquarykeysanctum6.webp",
    "Azmeri Reliquary Key|twilightorderreliquarykeyazmeri.webp",
  ]
},
/***************************************************
 * 0.3.0 Stuff
 ***************************************************/
{
  "itemType": "Lineage Gems",
  "itemClass": "Support Gems",
  "currencySearchName": '"\'s " "s\' " "Prototype Seventeen" "Her Declaration"',
  "isCurrency": true,
  "imageBaseUrl": "/img/currency/lineagegems/",
  "baseTypes": [
    "Atalui's Bloodletting|LineageLifetap.png",
    "Einhar's Beastrite|LineageEinhar.png",
    "Vilenta's Propulsion|LineageVilenta.png",
    "Ahn's Citadel|LineageAhnChisel.png",
    "Brutus' Brain|LineageMeatshield.png",
    "Tecrod's Revenge|LineageTecrod.png",
    "Uruk's Smelting|LineageArmourBreak.png",
    "Paquate's Pact|Paquate.png",
    "Ailith's Chimes|Monastic.png",
    "Doedre's Undoing|LineageDoedre.png",
    "Ratha's Assault|Azadian.png",
    "Arjun's Medal|AmmoConservation.png",
    "Kaom's Madness|LineageKaom.png",
    "Sione's Temper|Wildshards.png",
    "Ixchel's Torment|Trialmaster.png",
    "Romira's Requital|LineageRomira.webp",
    "Tawhoa's Tending|Tukohama.png",
    "Dominus' Grasp|LineageMercy.png",
    "Dialla's Desire|Dialla.png",
    "Kalisa's Crescendo|LineageKalisaChorus.webp",
    "Xoph's Pyre|LineageXoph.png",
    "Esh's Radiance|LineageEsh.png",
    "Tul's Stillness|LineageTul.png",
    "Uul-Netol's Embrace|LineageUulNetol.png",
    "Rakiata's Flow|Rakiata.png",
    "Rigwald's Ferocity|Rigwald.png",
    "Uhtred's Exodus|LineageUhtredLesser.png",
    "Uhtred's Omen|LineageUhtredStandard.png",
    "Uhtred's Augury|LineageUhtredGreater.png",
    "Daresso's Passion|LineageDaresso.png",
    "Atziri's Allure|LineageAtziri.png",
    "Tacati's Ire|LineageTacati.png",
    "Zarokh's Refrain|Zarokh.png",
    "Garukhan's Resolve|Garukhan.png",
    "Kurgal's Leash|AbyssKurgal.png",
    "Kulemak's Dominion|LineageKulemakSpire.png",
    "Amanamu's Tithe|LineageAmanamu.webp",
    "Varashta's Blessing|LineageDjinn.png",
    "Arbiter's Ignition|LineageArbiter.png",
    "Arakaali's Lust|LineageArakaali.png",
    /***************************************************
     * 0.4.0
     ***************************************************/
    "Xibaqua's Rending|LineageXibaqua.png",
    "Oisín's Oath|WalkeroftheWilds.png",
    "Tasalio's Rhythm|LineageTasalio.png",
    "Dreamer's Knell|LineageDreamer.png",
    "Khatal's Rejuvenation|LineageKhatal.png",
    "Atziri's Call|BlankRedSupportGem.png",
    "Guatelitzi's Ablation|Guatelitzi.png",
    "Morgana's Tempest|MorganasTempest.png",
    "Hayoxi's Fulmination|Hayoxi.png",
    "Bhatair's Vengeance|ShatteredFang.png",
    "Atziri's Impatience|AtziriImpatience.png",
    "Zarokh's Revolt|ZarokhsRevolt.png",
    "Zerphi's Infamy|ZerphisLegacy.png",
    "Cirel's Cultivation|Greatwood.png",
    /***************************************************
     * 0.5.0
     ***************************************************/
    "Helbrym's Hide|HideofHelbrym.png",
    "Eonyr's Thunder|ScaleofEonyr.png",
    "Tangmazu's Thurible|TangmazusThurible.webp",
    "Catha's Brilliance|CathasBrilliance.webp",
    "Mórrigan's Insight|MorrigansRefuge.webp",
    "Arbiter's Reach|MothersWard.webp",
    "Seraph's Heart|SeraphsHeart.webp",
    "Trickster's Shard|TrickstersShard.webp",
    "Esh's Prowess|EshsProwess.webp",
    "Tul's Avalanche|TulsProgeny.webp",
    "Breachlord's Amalgam|BreachlordsAmalgam.webp",
    "Vruun's Aftermath|VruunsAftermath.webp",
    "Vruun's Inevitability|VruunsSpike.webp",
    "Uhtred's Rite|UthredsChalice.webp",
    "Uhtred's Constellation|UhtredsConstellation.webp",
    "Medved's Felling|MedvedsFelling.webp",
    "Vorana's Siege|VoranasSiege.webp",
    "Styrn's Mountain|KnightsLegacy.webp",
    "Styrn's Ferocity|KnightsFerocity.webp",
    "Olroth's Conviction|OlrothsConviction.webp",
    "Olroth's Hubris|OlrothsHubris.webp",
    "Prototype Seventeen|PrototypeSeventeen.webp",
    "Her Declaration|MothersDeclaration.webp",
    "Atziri's Communion|AtziriCommunion.webp", // 0.5.1
    "Breachlord's Rift|BreachlordsRemorse.webp", // ?
  ]
},
/***************************************************
 * 0.4.0 Stuff
 ***************************************************/
{
  "itemType": "Incubators",
  "itemClass": "Incubators",
  "currencySearchName": "Incubator",
  "imageBaseUrl": "",
  "isCurrency": true,
  "content": EndgameContent.Temple,
  "baseTypes": [
    "Vaal Siphoner|/img/currency/VaalSiphoner.png",
  ]
},
/***************************************************
 * 0.5 Return of the Ancients Currency - TODO: update images
 ***************************************************/
{
  "itemType": "Wombgifts",
  "itemClass": "Wombgifts",
  "currencySearchName": "Wombgift",
  "imageBaseUrl": "/img/currency/breach/",
  "content": EndgameContent.Breach,
  "isCurrency": true,
  "baseTypes": [
    "Ornate Wombgift|BreachFruit1.webp",
    "Lavish Wombgift|BreachFruit2.webp",
    "Revelatory Wombgift|BreachFruit3.webp",
    "Banded Wombgift|BreachFruit4.webp",
    "Signet Wombgift|BreachFruit5.webp",
  ]
},
{
  "itemType": "Alloys",
  "itemClass": "Stackable Currency",
  "currencySearchName": "Alloy",
  "imageBaseUrl": "/img/currency/",
  "content": EndgameContent.Expedition,
  "isCurrency": true,
  "baseTypes": [
    "Runic Alloy|ScrapVerisium.webp",
    "Adaptive Alloy|ChippedVerisium.webp",
    "Protective Alloy|ImpureVerisium.webp",
    "Expansive Alloy|StandardVerisium.webp",
    "Swift Alloy|PureVerisium.webp",
    "Cyclonic Alloy|ImbuedVerisium.webp",
    "Prismatic Alloy|SovereignVerisium.webp",
    "Mystic Alloy|CelestialVerisium.webp",
    "Sovereign Alloy|Alloy1.webp",
    "Celestial Alloy|Alloy4.webp",
    "Transcendent Alloy|Alloy5.webp",
    "The Runebinder's Alloy|Alloy2.webp",
    "The Runefather's Alloy|Alloy3.webp",
  ]
},
{
  "itemType": "Ores",
  "itemClass": "Stackable Currency",
  "currencySearchName": "Ore",
  "imageBaseUrl": "/img/currency/",
  "content": EndgameContent.Expedition,
  "isCurrency": true,
  "baseTypes": [
    "Venerable Starlit Ore|VerisiumOre_Starlit_2x3.webp",
    "Revered Starlit Ore|VerisiumOre_Starlit_2x4_Armour.webp",
    "Veridical Starlit Ore|VerisiumOre_Starlit_1x1.webp",
    "Warding Starlit Ore|VerisiumOre_Starlit_2x4_Weapon.webp",
    "Starlit Ore|VerisiumOre_Starlit_2x2.webp",
  ]
},
{
  "itemType": "Fluxes",
  "itemClass": "Stackable Currency",
  "currencySearchName": "Flux",
  "imageBaseUrl": "/img/currency/",
  "content": EndgameContent.Expedition,
  "isCurrency": true,
  "baseTypes": [
    "Blazing Flux|ArcaneFluxFire.webp",
    "Chilling Flux|ArcaneFluxCold.webp",
    "Crackling Flux|ArcaneFluxLightning.webp",
    "Void Flux|ArcaneFlux.webp",
    "Perfect Flux|ExpeditionGemCurrencyPowerful.webp",
    "Thaumaturgic Flux (Level 5)|ExpeditionGemCurrency.webp",
    "Thaumaturgic Flux (Level 6)|ExpeditionGemCurrency.webp",
    "Thaumaturgic Flux (Level 7)|ExpeditionGemCurrency.webp",
    "Thaumaturgic Flux (Level 8)|ExpeditionGemCurrency.webp",
    "Thaumaturgic Flux (Level 9)|ExpeditionGemCurrency.webp",
    "Thaumaturgic Flux (Level 10)|ExpeditionGemCurrency.webp",
    "Thaumaturgic Flux (Level 11)|ExpeditionGemCurrency.webp",
    "Thaumaturgic Flux (Level 12)|ExpeditionGemCurrency.webp",
    "Thaumaturgic Flux (Level 13)|ExpeditionGemCurrency.webp",
    "Thaumaturgic Flux (Level 14)|ExpeditionGemCurrency.webp",
    "Thaumaturgic Flux (Level 15)|ExpeditionGemCurrency.webp",
    "Thaumaturgic Flux (Level 16)|ExpeditionGemCurrency.webp",
    "Thaumaturgic Flux (Level 17)|ExpeditionGemCurrency.webp",
    "Thaumaturgic Flux (Level 18)|ExpeditionGemCurrency.webp",
    "Thaumaturgic Flux (Level 19)|ExpeditionGemCurrency.webp",
    "Thaumaturgic Flux (Level 20)|ExpeditionGemCurrency.webp",
  ]
},
{
  "itemType": "Regular Runes",
  "itemClass": "Augment",
  "currencySearchName": regularRuneBaseTypeEntries.map(([name]) => `"${name.slice(0, -5)}"`).join(' '),
  "imageBaseUrl": "/img/currency/runes/",
  "isCurrency": true,
  "baseTypes": regularRuneBaseTypeEntries.map(([name, img]) => `${name}|${img}`),
},
{
  // Existing (images are correct)
  "itemType": "Megalith Runes",
  "itemClass": "Augment",
  "currencySearchName": "Greater Rune of ",
  "imageBaseUrl": "/img/currency/runes/",
  "content": EndgameContent.UniqueMap,
  "isCurrency": true,
  "baseTypes": [
    "Greater Rune of Leadership|lightningrunespecial1.webp",
    "Greater Rune of Tithing|lightningrunespecial2.webp",
    "Greater Rune of Alacrity|lightningrunespecial3.webp",
    "Greater Rune of Nobility|lightningrunespecial4.webp",
  ]
},
{
  // Existing (images are correct)
  "itemType": "Lineage Runes",
  "itemClass": "Augment",
  "currencySearchName": '"\'s Rune of" "\' Rune of"',
  "imageBaseUrl": "/img/currency/runes/",
  "isCurrency": true,
  "baseTypes": [
    "Hedgewitch Assandra's Rune of Wisdom|newrune1.webp",
    "Saqawal's Rune of the Sky|newrune2.webp",
    "Fenumus' Rune of Agony|newrune3.webp",
    "Farrul's Rune of Grace|newrune4.webp",
    "Farrul's Rune of the Chase|newrune5.webp",
    "Craiceann's Rune of Warding|newrune6.webp",
    "Saqawal's Rune of Memory|newrune7.webp",
    "Saqawal's Rune of Erosion|newrune8.webp",
    "Farrul's Rune of the Hunt|newrune9.webp",
    "Craiceann's Rune of Recovery|newrune10.webp",
    "Courtesan Mannan's Rune of Cruelty|newrune11.webp",
    "Thane Grannell's Rune of Mastery|newrune12.webp",
    "Fenumus' Rune of Spinning|newrune13.webp",
    "Countess Seske's Rune of Archery|newrune14.webp",
    "Thane Girt's Rune of Wildness|newrune15.webp",
    "Fenumus' Rune of Draining|newrune16.webp",
    "Thane Myrk's Rune of Summer|newrune17.webp",
    "Lady Hestra's Rune of Winter|newrune18.webp",
    "Thane Leld's Rune of Spring|newrune19.webp",
    "The Greatwolf's Rune of Claws|newrune20.webp",
    "The Greatwolf's Rune of Willpower|newrune21.webp"
  ]
},
{
  "itemType": "Perfect Runes",
  "itemClass": "Augment",
  "currencySearchName": 'Perfect ',
  "imageBaseUrl": "/img/currency/runes/",
  "isCurrency": true,
  "baseTypes": [
    "Perfect Desert Rune|firerunetier2.webp",
    "Perfect Glacial Rune|coldrunetier2.webp",
    "Perfect Storm Rune|lightningrunetier2.webp",
    "Perfect Iron Rune|enhancerunetier2.webp",
    "Perfect Body Rune|liferunetier2.webp",
    "Perfect Mind Rune|manarunetier2.webp",
    "Perfect Rebirth Rune|liferecoveryrunetier2.webp",
    "Perfect Inspiration Rune|manarecoveryrunetier2.webp",
    "Perfect Stone Rune|stunrunetier2.webp",
    "Perfect Vision Rune|accuracyrunetier2.webp",
    "Perfect Robust Rune|strengthrunetier3.webp",
    "Perfect Adept Rune|dexrunetier3.webp",
    "Perfect Resolve Rune|intrunetier3.webp",

    "Perfect Ward Rune|AddedWardPerfect.webp",
    "Perfect Charging Rune|WardRegenerationPerfect.webp",
  ]
},
{
  "itemType": "Ancient Augments",
  "itemClass": "Augment",
  "currencySearchName": '"Raven-Touched Shard" "Emergent " "Carved "',
  "imageBaseUrl": "/img/currency/runes/",
  "isCurrency": true,
  "baseTypes": [
    "Raven-Touched Shard|DeliriumEndgameSocketable.webp",
    "Emergent Vigour|ExpeditionReligionAncientAugment.webp",
    "Emergent Possibility|ExpeditionScienceAncientAugment.webp",
    "Emergent Protection|ExpeditionValorAncientAugment.webp",
    "Emergent Instinct|ExpeditionWarAncientAugment.webp",
    "Carved Cunning|RitualAmbushPredators.webp",
    "Carved Majesty|RitualMajesticBeasts.webp",
    "Carved Mischief|RitualMischievousCreatures.webp",
    "Carved Tenacity|RitualTenaciousBeasts.webp",
  ]
},
{
  "itemType": "Vaal Theses",
  "itemClass": "Augment",
  "currencySearchName": 'Thesis',
  "imageBaseUrl": "/img/currency/soulcores/",
  "content": EndgameContent.Temple,
  "isCurrency": true,
  "baseTypes": [
    "Guatelitzi's Thesis|soulcoreblood.webp",
    "Citaqualotl's Thesis|soulcoresacrifice.webp",
    "Jiquani's Thesis|soulcoresoul.webp",
    "Quipolatl's Thesis|soulcorescience.webp"
  ]
},
{
  "itemType": "Mythical Runes",
  "itemClass": "Augment",
  "currencySearchName": '"Rune of Vitality" "Rune of the Hunt" "Rune of Acrobatics" "Rune of Culmination" "Rune of Renown" "Rune of Accumulation" "Rune of Foundations" "Rune of the Prism" "Rune of the Blossom" "Rune of Consistency" "Rune of Reach" "Rune of Vital Flame" "Rune of Confrontation"',
  "imageBaseUrl": "/img/currency/runes/",
  "content": EndgameContent.Expedition,
  "isCurrency": true,
  "baseTypes": [
    "Rune of Vitality|EarlyMythicRune1.webp",
    "Rune of the Hunt|EarlyMythicRune2.webp",
    "Rune of Acrobatics|EarlyMythicRune3.webp",
    "Rune of Culmination|EarlyMythicRune4.webp",
    "Rune of Renown|EarlyMythicRune5.webp",
    "Rune of Accumulation|EarlyMythicRune6.webp",
    "Rune of Foundations|EarlyMythicRune7.webp",
    "Rune of the Prism|EarlyMythicRune8.webp",
    "Rune of the Blossom|EarlyMythicRune9.webp",
    "Rune of Consistency|EarlyMythicRune10.webp",
    "Rune of Reach|EarlyMythicRune11.webp",
    "Rune of Vital Flame|EarlyMythicRune12.webp",
    "Rune of Confrontation|EarlyMythicRune13.webp",
  ]
},
{
  "itemType": "Meta-Crafting Runes",
  "itemClass": "Augment",
  "currencySearchName": '"Masterwork Rune" "Aldur\'s Legacy" "Passion of Aldur" "Breath of Aldur" "Ire of Aldur" "Betrayal of Aldur" "Serle\'s Triumph" "Cadigan\'s Epiphany" "Astrid\'s Creativity" "Uhtred\'s Sidereus" "Kolr\'s Hunt" "Vorana\'s Carnage" "Thrud\'s Might" "Medved\'s Tending" "Katla\'s Gloom"',
  "imageBaseUrl": "/img/currency/runes/",
  "content": EndgameContent.Expedition,
  "isCurrency": true,
  "baseTypes": [
    // Upgrade rune
    "Masterwork Rune|UpgradeRune.webp",
    // Change unique into rune
    "Aldur's Legacy|GameWarpRuneUnique.webp",
    // Convert elements
    "Passion of Aldur|ElementalConversionRuneFire.webp",
    "Breath of Aldur|ElementalConversionRuneCold.webp",
    "Ire of Aldur|ElementalConversionRuneLightning.webp",
    "Betrayal of Aldur|ElementalConversionRuneChaos.webp",
    // Meta-crafting
    "Serle's Triumph|GameWarpRune2.webp",
    "Cadigan's Epiphany|GameWarpRune3.webp",
    "Astrid's Creativity|GameWarpRune1.webp",
    "Uhtred's Sidereus|GameWarpRuneTime.webp",
    "Kolr's Hunt|GameWarpRuneDex.webp",
    "Vorana's Carnage|GameWarpRunePhysical.webp",
    "Thrud's Might|GameWarpRuneFire.webp",
    "Medved's Tending|GameWarpRuneCold.webp",
    "Katla's Gloom|GameWarpRuneChaos.webp",
  ]
},
{
  "itemType": "Legacy Runes",
  "itemClass": "Augment",
  "currencySearchName": 'Legacy of ',
  "imageBaseUrl": "/img/currency/runes/",
  "content": EndgameContent.Expedition,
  "isCurrency": true,
  "baseTypes": [
    "Legacy of Bramblejack|GameWarpRuneUniqueFragment.webp",
    "Legacy of Blackbraid|GameWarpRuneUniqueFragment.webp",
    "Legacy of Edyrns Tusks|GameWarpRuneUniqueFragment.webp",
    "Legacy of Kingsguard|GameWarpRuneUniqueFragment.webp",
    "Legacy of Bristleboar|GameWarpRuneUniqueFragment.webp",
    "Legacy of Foxshade|GameWarpRuneUniqueFragment.webp",
    "Legacy of Ashrend|GameWarpRuneUniqueFragment.webp",
    "Legacy of Briskwrap|GameWarpRuneUniqueFragment.webp",
    "Legacy of The Unleashed|GameWarpRuneUniqueFragment.webp",
    "Legacy of Horns of Bynden|GameWarpRuneUniqueFragment.webp",
    "Legacy of Wings of Caelyn|GameWarpRuneUniqueFragment.webp",
    "Legacy of Ezomyte Peak|GameWarpRuneUniqueFragment.webp",
    "Legacy of Deidbell|GameWarpRuneUniqueFragment.webp",
    "Legacy of Elevore|GameWarpRuneUniqueFragment.webp",
    "Legacy of Starkonja's Head|GameWarpRuneUniqueFragment.webp",
    "Legacy of Crown of Thorns|GameWarpRuneUniqueFragment.webp",
    "Legacy of Greymake|GameWarpRuneUniqueFragment.webp",
    "Legacy of Erian's Cobble|GameWarpRuneUniqueFragment.webp",
    "Legacy of The Smiling Knight|GameWarpRuneUniqueFragment.webp",
    "Legacy of The Vile Knight|GameWarpRuneUniqueFragment.webp",
    "Legacy of Northpaw|GameWarpRuneUniqueFragment.webp",
    "Legacy of Candlemaker|GameWarpRuneUniqueFragment.webp",
    "Legacy of Deathblow|GameWarpRuneUniqueFragment.webp",
    "Legacy of Legionstride|GameWarpRuneUniqueFragment.webp",
    "Legacy of Trampletoe|GameWarpRuneUniqueFragment.webp",
    "Legacy of Briarpatch|GameWarpRuneUniqueFragment.webp",
    "Legacy of Bushwhack|GameWarpRuneUniqueFragment.webp",
    "Legacy of Wanderlust|GameWarpRuneUniqueFragment.webp",
    "Legacy of The Knight-errant|GameWarpRuneUniqueFragment.webp",
    "Legacy of Obern's Bastion|GameWarpRuneUniqueFragment.webp",
    "Legacy of Dionadair|GameWarpRuneUniqueFragment.webp",
    "Legacy of Wulfsbane|GameWarpRuneUniqueFragment.webp",
    "Legacy of Chernobog's Pillar|GameWarpRuneUniqueFragment.webp",
    "Legacy of Alkem Eira|GameWarpRuneUniqueFragment.webp",
    "Legacy of Oaksworn|GameWarpRuneUniqueFragment.webp",
    "Legacy of Dunkelhalt|GameWarpRuneUniqueFragment.webp",
    "Legacy of Rondel de Ezo|GameWarpRuneUniqueFragment.webp",
    "Legacy of Brynhand's Mark|GameWarpRuneUniqueFragment.webp",
    "Legacy of Trenchtimbre|GameWarpRuneUniqueFragment.webp",
    "Legacy of Mjölner|GameWarpRuneUniqueFragment.webp",
    "Legacy of Twisted Empyrean|GameWarpRuneUniqueFragment.webp",
    "Legacy of Hoghunt|GameWarpRuneUniqueFragment.webp",
    "Legacy of Hrimnor's Hymn|GameWarpRuneUniqueFragment.webp",
    "Legacy of Brain Rattler|GameWarpRuneUniqueFragment.webp",
    "Legacy of Lifesprig|GameWarpRuneUniqueFragment.webp",
    "Legacy of Duality|GameWarpRuneUniqueFragment.webp",
    "Legacy of Tyranny's Grip|GameWarpRuneUniqueFragment.webp",
    "Legacy of The Sentry|GameWarpRuneUniqueFragment.webp",
    "Legacy of Adonia's Ego|GameWarpRuneUniqueFragment.webp",
    "Legacy of Cursecarver|GameWarpRuneUniqueFragment.webp",
    "Legacy of Dusk Vigil|GameWarpRuneUniqueFragment.webp",
    "Legacy of The Blood Thorn|GameWarpRuneUniqueFragment.webp",
    "Legacy of Quill Rain|GameWarpRuneUniqueFragment.webp",
    "Legacy of Ironbound|GameWarpRuneUniqueFragment.webp",
    "Legacy of Amor Mandragora|GameWarpRuneUniqueFragment.webp",
    "Legacy of Spiteful Floret|GameWarpRuneUniqueFragment.webp",
    "Legacy of Svalinn|GameWarpRuneUniqueFragment.webp",
    "Legacy of Keeper of the Arc|GameWarpRuneUniqueFragment.webp",
    "Legacy of Olrovasara|GameWarpRuneUniqueFragment.webp",
    "Legacy of A Worthy Foe|GameWarpRuneUniqueFragment.webp",
    "Legacy of Serle's Grit|GameWarpRuneUniqueFragment.webp",
    "Legacy of Runeseeker's Call|GameWarpRuneUniqueFragment.webp",
    "Legacy of Facebreaker|GameWarpRuneUniqueFragment.webp",
    // "Legacy of Hysseg's Claw|legacy-rune-tmp.webp",
  ]
},
{
  "itemType": "Warding Runes",
  "itemClass": "Augment",
  "currencySearchName": 'Warding Rune of ',
  "imageBaseUrl": "/img/currency/runes/",
  "isCurrency": true,
  "baseTypes": [
    "Warding Rune of Reinforcement|RunicWard1.webp",
    "Warding Rune of Protection|RunicWard2.webp",
    "Warding Rune of Disintegration|RunicWard3.webp",
    "Warding Rune of Desperation|RunicWard4.webp",
    "Warding Rune of Symbiosis|RunicWard8.webp",
    "Warding Rune of Courage|RunicWard9.webp",
    "Warding Rune of Stability|RunicWard10.webp",
    "Warding Rune of Glancing|RunicWard13.webp",
    "Warding Rune of Heart|RunicWard14.webp",
    "Warding Rune of Nourishment|RunicWard15.webp",
    "Warding Rune of Annihilation|RunicWard16.webp",
    "Warding Rune of Armature|RunicWard18.webp",
    "Warding Rune of Obsession|RunicWard19.webp",
    "Warding Rune of Equinox|RunicWard20.webp",
    "Warding Rune of Salvaging|RunicWard21.webp",
    "Warding Rune of Bodyguards|RunicWard23.webp",
    "Warding Rune of Hollowing|RunicWard24.webp",
  ]
},
{
  "itemType": "Ancient Runes",
  "itemClass": "Augment",
  "currencySearchName": 'Ancient Rune of ',
  "imageBaseUrl": "/img/currency/runes/",
  "content": EndgameContent.Expedition,
  "isCurrency": true,
  "baseTypes": [
    "Ancient Rune of Splinters|EndgameRune1.webp",
    "Ancient Rune of Dueling|EndgameRune2.webp",
    "Ancient Rune of the Titan|EndgameRune3.webp",
    "Ancient Rune of Shattering|EndgameRune4.webp",
    "Ancient Rune of Prowess|EndgameRune5.webp",
    "Ancient Rune of Control|EndgameRune6.webp",
    "Ancient Rune of Discovery|EndgameRune7.webp",
    "Ancient Rune of Decay|EndgameRune8.webp",
    "Ancient Rune of Witchcraft|EndgameRune9.webp",
    "Ancient Rune of the Horde|EndgameRune10.webp",
    "Ancient Rune of Animosity|EndgameRune11.webp",
    "Ancient Rune of Detonation|EndgameRune12.webp",
    "Ancient Rune of Retaliation|EndgameRune13.webp",
  ]
},
/***************************************************
 * 0.5 Return of the Ancients Gems - TODO: update images
 ***************************************************/
{
  "itemType": "Kalguuran Skill Gems",
  "itemClass": "Skill Gems",
  "currencySearchName": '"Animus Exchange" "Animus Splinters" "Bitter Dead" "Conductive Runes" "Detonate Living" "Eternal March" "Explosive Transmutation" "Fragments of the Past" "Frostflame Nova" "Grim Pillars" "Hollow Shell" "Leylines" "Powered by Verisium" "Rain of Blades" "Refutation" "Remnants of Kalguur" "Repulsion" "Runic Reprieve" "Skyfall" "Triskelion Cascade" "Verisium Manifestations" "Voltaic Barrier" "Wardbound Minions"',
  "isCurrency": true,
  "imageBaseUrl": "/img/currency/kalguurangems/",
  "content": EndgameContent.Expedition,
  "baseTypes": [
    "Animus Exchange|kalguuran-gem-tmp.png",
    "Animus Splinters|kalguuran-gem-tmp.png",
    "Bitter Dead|kalguuran-gem-tmp.png",
    "Conductive Runes|kalguuran-gem-tmp.png",
    "Detonate Living|kalguuran-gem-tmp.png",
    "Eternal March|kalguuran-gem-tmp.png",
    "Explosive Transmutation|kalguuran-gem-tmp.png",
    "Fragments of the Past|kalguuran-gem-tmp.png",
    "Frostflame Nova|kalguuran-gem-tmp.png",
    "Grim Pillars|kalguuran-gem-tmp.png",
    "Hollow Shell|kalguuran-gem-tmp.png",
    "Leylines|kalguuran-gem-tmp.png",
    "Powered by Verisium|kalguuran-gem-tmp.png",
    "Rain of Blades|kalguuran-gem-tmp.png",
    "Refutation|kalguuran-gem-tmp.png",
    "Remnants of Kalguur|kalguuran-gem-tmp.png",
    "Repulsion|kalguuran-gem-tmp.png",
    "Runic Reprieve|kalguuran-gem-tmp.png",
    "Skyfall|kalguuran-gem-tmp.png",
    "Triskelion Cascade|kalguuran-gem-tmp.png",
    "Verisium Manifestations|kalguuran-gem-tmp.png",
    "Voltaic Barrier|kalguuran-gem-tmp.png",
    "Wardbound Minions|kalguuran-gem-tmp.png",
  ]
},
{
  "itemType": "Kalguuran Support Gems",
  "itemClass": "Support Gems",
  "currencySearchName": '"Concussive Runes" "Fist of Kalguur" "Healing Runes" "Runeforged Blades" "Runic Extraction" "Runic Infusion" "Scouring Flame"',
  "isCurrency": true,
  "imageBaseUrl": "/img/currency/kalguurangems/",
  "content": EndgameContent.Expedition,
  "baseTypes": [
    "Concussive Runes|kalguuran-support-gem-tmp.png",
    "Fist of Kalguur|kalguuran-support-gem-tmp.png",
    "Healing Runes|kalguuran-support-gem-tmp.png",
    "Runeforged Blades|kalguuran-support-gem-tmp.png",
    "Runic Extraction|kalguuran-support-gem-tmp.png",
    "Runic Infusion|kalguuran-support-gem-tmp.png",
    "Scouring Flame|kalguuran-support-gem-tmp.png",
  ]
}
];
